import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SortingItem } from '@lx/shared/types';
import { valueIsNullOrUndefined } from '@lx/shared/utils';
import { Dropdown, DropdownChangeEvent } from 'primeng/dropdown';
import { KeyValueLabel } from '../../types/key-value-item.type';

@Component({
  selector: 'lx-sort',
  templateUrl: './sort.component.html',
  styleUrls: ['./sort.component.scss'],
})
export class SortComponent<T> implements OnInit, OnChanges {
  @ViewChild('dropdown') dropdown: Dropdown | undefined;

  @Input() set sortingOptions(options: KeyValueLabel<string, SortingItem<T>>[]) {
    if (options.length) {
      this._sortingOptions = options;
    }
  }

  get sortingOptions(): KeyValueLabel<string, SortingItem<T>>[] {
    return this._sortingOptions;
  }

  @Input() displayExpr: string | ((Object) => string);
  @Input() valueExpr: string | ((Object) => string | number | boolean);
  @Input() selectedValue: string;
  @Output() sortChanges: EventEmitter<SortingItem<T>> = new EventEmitter<SortingItem<T>>();

  protected isOpened: boolean;
  protected selectedItem: SortingItem<T> | undefined;
  protected selectedLabel = '';

  private _sortingOptions: KeyValueLabel<string, SortingItem<T>>[] = [];

  constructor() {
    this.displayExpr = 'label';
    this.valueExpr = 'key';
  }

  ngOnInit() {
    if (this.selectedValue) {
      this.setSelectedValue(this.selectedValue, this.sortingOptions);
    }
  }

  ngOnChanges({ selectedValue, sortingOptions }: SimpleChanges): void {
    if (selectedValue) {
      this.setSelectedValue(selectedValue.currentValue, this.sortingOptions);
    }
    if (sortingOptions && sortingOptions.currentValue.length) {
      if (this.selectedValue) {
        // Re-apply selectedValue now that options are available
        this.setSelectedValue(this.selectedValue, sortingOptions.currentValue);
      } else {
        // Default to first option only when there's no selection
        this.setSelectedValue(sortingOptions.currentValue[0].key, sortingOptions.currentValue);
      }
    }
  }

  selectedItemChanges($event: DropdownChangeEvent): void {
    if ($event) {
      const selectedOption = this.sortingOptions.find((option) => option.value === $event.value);
      this.selectedLabel = selectedOption?.label || '';
      this.sortChanges.emit($event.value);
    }
  }

  getDropdownIcon() {
    return this.dropdown && this.dropdown.overlayVisible ? 'pi pi-chevron-up' : 'pi pi-chevron-down';
  }

  toggleDropdown(isOpened: boolean) {
    this.isOpened = isOpened;
  }

  private setSelectedValue(value: string, sortingOptions: KeyValueLabel<string, SortingItem<T>>[]): void {
    const selectedOption = valueIsNullOrUndefined(value) ? sortingOptions[0] : sortingOptions.find((sortingOption) => sortingOption.key === value);

    this.selectedItem = selectedOption?.value;
    this.selectedLabel = selectedOption?.label || '';
  }
}
